<template>
    <div>
        <b-form-group
            :label="field.label"
            :label-for="`id_${field._id}`"
            :class="{
                'required-field': isTaxIdMandatory,
            }"
        >
            <b-form-input
                v-model="model"
                v-validate="{
                    required: isTaxIdMandatory,
                    email: !!field.isEmail,
                    numeric: !!field.isNumeric,
                }"
                type="text"
                autocomplete="no"
                :placeholder="field.placeholder"
                :disabled="loading || !isTaxIdRequired"
                :data-vv-name="field.label"
                :class="{
                    'is-invalid': errors.has(field.label),
                }"
            ></b-form-input>
            <p v-if="taxIdNote" class="tax-instruction">
                <i class="icon-error_outline"></i>
                <span>
                    {{ taxIdNote }}
                </span>
            </p>
        </b-form-group>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import TextField from './TextField'
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: TextField, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapState({
            isTaxIdRequired: (state) => state.registration.isTaxIdRequired,

            isTaxIdMandatory: (state) => state.registration.isTaxIdMandatory,

            taxIdNote: (state) => state.registration.taxIdNote,
        }),
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        isTaxIdRequired(value) {
            if (!value) {
                this.model = null
            }
        },
    }, // End of Component > watch
}
</script>
